import React from 'react';
import classes from './sectionTitle.module.css';

var SectionTitle = function SectionTitle(_ref) {
  var title = _ref.title,
      _ref$isPdf = _ref.isPdf,
      isPdf = _ref$isPdf === void 0 ? false : _ref$isPdf;
  return React.createElement("h5", {
    className: "".concat(classes.title, " ").concat(isPdf && classes.pdfTitle)
  }, title);
};

export default SectionTitle;